module.exports = "<div *ngIf=\"isLoading\">\n    <my-spinner></my-spinner>\n</div>\n<div *ngIf=\"!isLoading\" [innerHTML]=\"html\" class=\"terms\"></div>"